import script from "./HomePageContent.vue?vue&type=script&setup=true&lang=js"
export * from "./HomePageContent.vue?vue&type=script&setup=true&lang=js"

import "./HomePageContent.vue?vue&type=style&index=0&id=020c45e6&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-020c45e6"]])

export default __exports__